import { DSColor } from '@ppwr/poker'

export const PLAYER_COLORS: DSColor[] = [
  'Brand/Pink',
  'Brand/Maroon',
  'Brand/Blue',
  'Brand/Green',
  'Brand/Orange',
  'Brand/Purple',
  'Brand/Yellow',
]

export function buildPlayerColorMap(playerIds: string[]): Map<string, DSColor> {
  const map = new Map<string, DSColor>()
  playerIds.forEach((id, idx) => {
    map.set(id, PLAYER_COLORS[idx % PLAYER_COLORS.length])
  })
  return map
}
